module.exports = __webpack_public_path__ + "f5b61b396312432a8d60a4e6e290bd6e.jpg";